import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import NavMenu from "../nav/navMenu";
import TitleBanner from "../components/titleBanner";
import TopBar from "../components/topBar";
import BottomBanner from "../components/bottomBanner";
import EventVideoPaper from "../components/eventVideoPaper";
import SideBar from "../components/sideBar";
import axios, { Axios } from "axios";
import newsletters from "../data/newsletters.json"
import posters from "../data/posters.json"

const useStyles = makeStyles({
  container: {
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    margin: "0 0 20px 0",
    width: "100%",
  },
  box: {
    backgroundColor: "#ffffff",
    padding: "10px",
    margin: "10px",
    border: 1,
    borderColor: "primary.main",
  },
  paperContainer: {
    height: "100vh",
    zIndex: -1,
  },
  dropDownContainer: {
    margin: "0 0 20px 0",
  },
  sfilogo: {
    position: "inherited",
    top: "0",
    left: "0",
    height: "10%",
  },
  title: {
    position: "absolute",
    top: "20%",
    left: "10%",
    zIndex: 0,
  },
  navmenu: {
    zIndex: 1,
  },
  text: {
    padding: 20,
    alignSelf: "center",
    justifySelf: "center",
  },
  subtitle: {
    textAlign: "center",
  },
  button: {
    left: "35%",
  },
  topBar: {
    width: "100%",
    left: 0,
    top: 0,
    position: "absolute",
  },
});

const UnheardVoices = () => {
  const classes = useStyles();
  const colour = "secondary";
  const title = "Unheard";
  const data =   {
      id: 1,
      title: "Unheard",
      description:
        `Unheard is a powerful spoken-word video and collaborative research effort that gives voice to the often-overlooked experiences of patients and caregivers who feel unseen in health and social care. Created through a unique collaboration between researchers and an artist, the piece draws on real qualitative data to illuminate what it means to feel unheard, and why that matters. \n 
        It is a collaboration between five of our PhD Researchers, across three of our partner universities. The piece is based on the research of Vivienne Howard of Trinity College Dublin, Shannon Aisling Forde of Munster Technological University, and Joan Alaboson, Matthew McKenna, and Grevet Smith Moyo of Maynooth University. \n \n Written and performed by Cormac Fitzgerald. Directed by Daniel Culleton.\n \n`,
      url: "https://www.youtube.com/embed/_2mdLY8ZwaA?si=e1YObNNGTDuUPak7",
    }
  const [dbnewsletters, setDbnewsletters] = useState([]);

    useEffect(() => {
              newsletters.sort(function (a, b) {
                return (
                  new Date(b.publicationDate) - new Date(a.publicationDate)
                );
              });
              setDbnewsletters(newsletters)



  }, []);

  return (
    <>
      <TopBar className={classes.topBar} />
      <NavMenu props={colour} className={classes.navmenu}></NavMenu>
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <TitleBanner props={title} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} />
        <Grid item xs={12} sm={12} md={6} lg={6} order={{ xs: 1, sm: 1 }}>
            <EventVideoPaper props={data} />
        </Grid>

        <Grid item xs={0} sm={0} md={1} lg={1} />
        <Grid item xs={12} sm={12} md={4} lg={4} order={{ xs: 2, sm: 2 }}>
          {dbnewsletters[0] && <SideBar props={dbnewsletters[0]} />}
        </Grid>
      </Grid>
      <BottomBanner />
    </>
  );
};

export default UnheardVoices;
